import type { Routes } from '@angular/router';
import {
  authGuard,
  hasAccessGuard,
  newUserGuard,
  redirectFromAuthGuard,
  userModeGuard,
} from '@tvd/data-access/auth';
import { adminGuard } from '@tvd/data-access/auth';
import { redirectToOrg } from '@tvd/data-access/auth';
import { subscriptionGuard } from '@tvd/data-access/subscription';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('@tvd/feat/dashboard').then((m) => m.dashboardRoutes),
    canMatch: [
      authGuard,
      hasAccessGuard('viewer'),
      userModeGuard(['staff', 'all']),
      redirectToOrg,
    ],
    canActivate: [newUserGuard],
    // NOTE: paywall enforcement for the dashboard is handled reactively by
    // PaywallRedirector (registered in init.ts). Adding subscriptionGuard
    // to canActivate or canActivateChild here caused 404 loops because the
    // redirect target (/settings/billing) lives under this same route, so
    // the guard would re-fire on the destination and Angular eventually
    // bailed to /error/404. The PaywallRedirector listens to
    // NavigationEnd + signal changes and redirects without sitting in the
    // activation chain.
  },
  {
    path: 'auth',
    loadChildren: () => import('@tvd/feat/auth').then((m) => m.authRoutes),
    canMatch: [redirectFromAuthGuard],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('@tvd/feat/settings').then((m) => m.settingsRoutes),
    canMatch: [authGuard],
    data: { hasFooter: true },
  },
  {
    path: 'onboarding-wizard',
    loadChildren: () =>
      import('@tvd/feat/onboarding-wizard').then((m) => m.wizardRoutes),
    canActivate: [authGuard, subscriptionGuard],
  },
  {
    path: 'error',
    loadChildren: () => import('@tvd/feat/error').then((m) => m.errorRoutes),
  },
  {
    path: 'success',
    loadChildren: () =>
      import('@tvd/feat/success').then((m) => m.successRoutes),
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('@tvd/feat/contact').then((m) => m.contactRoutes),
  },
  {
    path: 'request-setup',
    loadChildren: () =>
      import('@tvd/feat/request-setup').then((m) => m.requestSetupRoutes),
  },
  {
    path: 'quiz',
    loadChildren: () => import('@tvd/feat/quiz').then((m) => m.quizRoutes),
    // resolve: { translations: loadScopedTranslations('quiz') },
  },
  {
    path: 'quiz-success',
    loadComponent: () =>
      import('@tvd/feat/quiz/quiz-success').then((m) => m.QuizSuccess),
  },
  {
    path: 'support/chat',
    loadChildren: () =>
      import('@tvd/feat/support-chat').then((m) => m.supportChatRoutes),
    canMatch: [authGuard],
  },
  {
    path: 'developer',
    loadChildren: () =>
      import('@tvd/feat/developer').then((m) => m.developerRoutes),
    canMatch: [adminGuard],
  },
  {
    path: '**',
    redirectTo: '/error/404',
  },
];
